import {ColDef, ColGroupDef} from 'ag-grid-community'
import {callSP} from '../../../../setup/axios/AxiosCallSP'
import {error, success, warn} from '../../../utils/customToasd'
import {propsInterfaceFormGroupInput} from '../../../utils/form/FormGroupInput'
import {ISitio, ITtipo} from './IMaintainer'
const columInput = 3
const styleInput = {width: '99%'}

export const getColumGridService = () => {
  const dataColum: (ColDef | ColGroupDef)[] = [
    {
      field: 'cli_nombre',
      headerName: 'Sitio',
      minWidth: 250,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'rec_nombre',
      headerName: 'Receta',
      minWidth: 300,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
    {
      field: 'TIPO',
      headerName: 'Tipo',
      minWidth: 120,
      suppressMenu: true,
      filter: true,
      floatingFilter: true,
    },
  ]
  return dataColum
}

export const getInputService = (
  optionSitio: ISitio[],
  optionTipo: ITtipo[],
  setLoad: any,
  setInputs: any
) => {
  if (optionSitio.length > 0) {
    optionSitio.forEach((item: ISitio) => {
      item.value = item.cli_codigo
      item.text = item.cli_nombre
    })
    optionTipo.forEach((item: ITtipo) => {
      item.value = item.codigo.toString()
      item.text = item.descripcion
    })
    let inputs: propsInterfaceFormGroupInput[] = []
    inputs.push(
      {
        columInput: columInput,
        style: styleInput,
        campo: 'sitio',
        label: 'Sitio',
        type: 'autocomplete',
        onChange: async (event, setFieldValue, values, arrayInput) => {
          setLoad(true)
          if (values?.sitio.length > 0) {
            setTimeout(async () => {
              const selectReceta = await callSP('amd_getRecetaByCeco', [
                {text: 'ceco', value: values.sitio[0].value.toString()},
              ])
              if (selectReceta.data.result.length > 0) {
                const data = selectReceta.data.result.map((value: any) => {
                  value.text = value.rec_nombre
                  value.value = value.rec_codigo
                  return value
                })
                arrayInput[1].advanceOptions.options = data
                setInputs(arrayInput)
                setLoad(false)
                setTimeout(() => {
                  setFieldValue('sitio', values.sitio)
                }, 2000)
              } else {
                setLoad(false)
              }
            }, 400)
          } else {
            setLoad(false)
          }
        },
        advanceOptions: {
          id: 'cliete',
          multiple: false,
          options: optionSitio,
        },
      },
      {
        columInput: columInput,
        style: styleInput,
        campo: 'receta',
        label: 'Receta',
        type: 'autocomplete',
        advanceOptions: {
          id: 'receta',
          multiple: false,
          options: [],
        },
      },
      {
        columInput: columInput,
        style: styleInput,
        campo: 'tipo',
        label: 'Tipo',
        type: 'autocomplete',
        advanceOptions: {
          id: 'tipo',
          multiple: false,
          options: optionTipo,
        },
      }
    )
    return inputs
  } else {
    return []
  }
}

type SaveData = (
  dataSave: any,
  getDataGrid: any,
  setShowModalMenu: (value: boolean) => void,
  setLoad: (value: boolean) => void
) => void

// TODO: actualizar admin si es requerido
export const saveData: SaveData = async (dataSave, getDataGrid, setShowModalMenu, setLoad) => {
  const {sitio, receta, tipo} = dataSave
  try {
    setLoad(true)
    await callSP('amd_InsertTable', [
      {text: 'tabla', value: 'amd_recetasCecoTipo'},
      {
        text: 'columnas',
        value: 'ceco,receta,tipo',
      },
      {
        text: 'valores',
        value: `${sitio[0].value},${receta[0].value},${tipo[0].value}`,
      },
    ])
    setLoad(false)
    success('Guardado exitosamente')
    getDataGrid()
    setShowModalMenu(false)
  } catch (error: any) {
    warn(error.result)
    setLoad(false)
  }
}

type UpdateData = (
    dataUpdate: any,
    getDataGrid: () => void,
    setShowModalMenu: (value: boolean) => void,
    setLoad: (value: boolean) => void
  ) => void
  
  export const updateData: UpdateData = async (
    dataUpdate,
    getDataGrid,
    setShowModalMenu,
    setLoad
  ) => {
    const { id, sitio, receta, tipo } = dataUpdate
  
    try {
      setLoad(true)
      await callSP('amd_UpdateTable', [
        {
          text: 'tabla',
          value: 'amd_recetasCecoTipo',
        },
        {
          text: 'columnas',
          value: 'ceco, receta, tipo',
        },
        {
          text: 'valores',
          value: `${sitio[0].value},${receta[0].value},${tipo[0].value}`,
        },
        {
          text: 'id',
          value: `${id}`,
        },
        {text: 'idN', value: 'id'},
      ])
      success('Guardado exitosamente')
      getDataGrid()
      setShowModalMenu(false)
      setLoad(false)
    } catch (err: any) {
      setLoad(false)
      error(err.result)
    }
  }
  
  type DeleteData = (
    id: number,
    setAlertModal: any,
    getDataGrid: () => void,
    setLoad: (value: boolean) => void
  ) => void
  // TODO: actualizar admin si es requerido
  export const deleteData: DeleteData = async (id, setAlertModal, getDataGrid, setLoad) => {
    try {
      setLoad(true)
      await callSP('amd_deleteTable', [
        {text: 'tabla', value: 'amd_usuario'},
        {text: 'id', value: `${id}`},
        {text: 'idN', value: 'idUsuario'},
      ])
      success('Se a eliminado con exito')
      getDataGrid()
      setAlertModal(undefined)
      setLoad(false)
    } catch (err: any) {
      setLoad(false)
      error(err.result)
    }
  }
